export default __webpack_public_path__ + "static/media/sensotrend_uploader_select_devices.4d8fb09b.png";